import { Button, Form, Switch } from 'antd';
import { useContext, useState } from 'react';

import { UserContext } from 'app/context/UserContext/UserContext';

import styles from '../PricingDrawer.module.scss';
import { usePackPricingScores } from '../hooks/usePackPricingScores';

import { LowPricingScoreModal } from './LowPricingScoreModal/LowPricingScoreModal';

type PricingFooterProps = {
  handleClose: () => void;
  handleSave: () => void;
};

export const PricingFooter = ({
  handleClose,
  handleSave,
}: PricingFooterProps) => {
  const { isAdmin } = useContext(UserContext);

  const form = Form.useFormInstance<{
    averageRoomPrice: number;
    defaultNightRoomDiscount: number;
  }>();

  const averageRoomPrice = Form.useWatch('averageRoomPrice', form);

  const { lowScorePacks, hasLowScore } = usePackPricingScores();

  const [isLowScoreModalOpen, setIsLowScoreModalOpen] = useState(false);

  const handleSaveClick = () => {
    if (isAdmin && hasLowScore) {
      setIsLowScoreModalOpen(true);

      return;
    }

    handleSave();
  };

  const handleConfirmSaveAnyway = () => {
    setIsLowScoreModalOpen(false);
    handleSave();
  };

  return (
    <div className={styles.footer}>
      <Form.Item shouldUpdate noStyle>
        {() => {
          const hasFormErrors = !!form
            .getFieldsError()
            .filter(({ errors }) => errors.length).length;

          const isDisabled = hasFormErrors || !averageRoomPrice;
          const isSaveDisabled = isDisabled || (!isAdmin && hasLowScore);

          return (
            <>
              <Button onClick={handleClose}>Cancel</Button>
              <div className={styles.footerRight}>
                <div className={styles.overrideWrapper}>
                  <span className={styles.overrideLabel}>
                    Override manual data
                  </span>
                  <Form.Item
                    name="overrideManualData"
                    valuePropName="checked"
                    noStyle
                  >
                    <Switch disabled={isDisabled} />
                  </Form.Item>
                </div>
                <Button
                  type="primary"
                  onClick={handleSaveClick}
                  disabled={isSaveDisabled}
                >
                  Save discounts
                </Button>
              </div>
            </>
          );
        }}
      </Form.Item>

      <LowPricingScoreModal
        isOpened={isLowScoreModalOpen}
        packNames={lowScorePacks.map((pack) => pack.name)}
        handleCancel={() => setIsLowScoreModalOpen(false)}
        handleSaveAnyway={handleConfirmSaveAnyway}
      />
    </div>
  );
};
